import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { useVideoController } from '../timeline/container/ElementContextMenu/useVideoController';
import { VideoFile } from "@mui/icons-material";
import CloseIcon from '@mui/icons-material/Close';
import AnimationOutlinedIcon from '@mui/icons-material/AnimationOutlined';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import CollectionsOutlinedIcon from '@mui/icons-material/CollectionsOutlined';
import GestureIcon from '@mui/icons-material/Gesture';
import FilterVintageOutlinedIcon from '@mui/icons-material/FilterVintageOutlined';
import SubtitlesOutlinedIcon from '@mui/icons-material/SubtitlesOutlined';
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import TextFieldsOutlinedIcon from '@mui/icons-material/TextFieldsOutlined';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import VideoLibraryOutlinedIcon from '@mui/icons-material/VideoLibraryOutlined';
import { Box, Button, Modal, Typography, useTheme } from '@mui/material';
import './menuBar.scss';

import Icondetail from './IconSection';
import { menubarRef_Store } from '../../../store/actions/editAction';
import { useUploadMedia } from '../tooltap/useUploadMedia';
import { loading_Store, menuID_Store } from '../../../store/actions/mainAction';
let mobileScreenDetect = false
  if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(navigator.userAgent||navigator.vendor||window.opera)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test((navigator.userAgent||navigator.vendor||window.opera).substr(0,4))){
    mobileScreenDetect = true;
  }

const isMobileViewport = () => window.matchMedia('(max-width: 992px)').matches || mobileScreenDetect;
  
export const MenuBar = () => {
  const dispatch = useDispatch();
  const menuRef = useRef();
  const menuID = useSelector(store => store.maindata.menuID);
  const ProjectJSON = useSelector(store => store.projectdata.projectJSON);
  const languageStrs = useSelector((store) => store.editdata.languageStrs);
  const uploadingFiles = useSelector((store) => store.projectdata.uploadingFiles);
  const themeMode = useTheme().palette.mode;
  const {deselectItems} = useVideoController();
  const {chooseVideoFunc} = useUploadMedia();
  const [searchParams] = useSearchParams();
  const [openShortsVideoUploadModal, setOpenShortsVideoUploadModal] = useState(false);
  const [hasRun, setHasRun] = useState(false);
  
  const from = searchParams.get('from');
  
  const menuinfo = [
    { Icon: <TuneOutlinedIcon className={`icon ${themeMode}`} />, title: languageStrs.setup, path: 'Settings', indexer: 0 },
    { Icon: <VideoLibraryOutlinedIcon className={`icon ${themeMode}`} />, title: languageStrs.media, path: 'Upload', indexer: 2 },
    { Icon: <SummarizeOutlinedIcon className={`icon ${themeMode}`} />, title: 'AI Summary', path: 'Summary', indexer: 3 },
    { Icon: <CollectionsOutlinedIcon className={`icon ${themeMode}`} />, title: languageStrs.stock, path: 'Stock', indexer: 4 },
    { Icon: <SubtitlesOutlinedIcon className={`icon ${themeMode}`} />, title: languageStrs.subtitles, path: 'Subtitles', indexer: 5 },
    { Icon: <AnimationOutlinedIcon className={`icon ${themeMode}`} />, title: languageStrs.transitions, path: 'Transitions', indexer: 7 },
    { Icon: <AutoAwesomeOutlinedIcon className={`icon ${themeMode}`} />, title: 'AI Visuals', path: 'Draw', indexer: 8 },
    { Icon: <TextFieldsOutlinedIcon className={`icon ${themeMode}`} />, title: languageStrs.text, path: 'Text', indexer: 9 },
    { Icon: <FilterVintageOutlinedIcon className={`icon ${themeMode}`} />, title: languageStrs.filters, path: 'Filters', indexer: 11 },
    { Icon: <GestureIcon className={`icon ${themeMode}`} />, title: languageStrs.draw, path: 'Draw', indexer: 12 },
  ]

  useEffect(() => {
    dispatch(menuID_Store(0))
  }, [])

  useEffect(() => {
    const uploadingFileKey = Object.keys(uploadingFiles || {})[0];
    const uploadingFile = uploadingFileKey ? uploadingFiles[uploadingFileKey] : null;

    if (!hasRun && ProjectJSON?.videos && ProjectJSON?.asset && from === "AIShorts") {
      if (Object.keys(ProjectJSON.videos).length > 0 && Object.keys(ProjectJSON.asset).length > 0 && uploadingFile?.state === true) {
        dispatch(loading_Store(false));
        dispatch(menuID_Store(3));
        setHasRun(true);
      }
    }
  }, [ProjectJSON, hasRun, uploadingFiles]);

  useEffect(() => {
    if(from === 'AIShorts' && menuID !== 3) {
      setOpenShortsVideoUploadModal(true);
    }

    const menu = menuRef.current;
    if (!menu) return;
    dispatch(menubarRef_Store(menu));
    if (!isMobileViewport()) {
      menu.children[menuID]?.click();
    }
    
  }, [menuID])

  const handleShortVideoUpload = async (event) => {
    const target = event.target;
    // console.log({target: target.files[0]});
    handleCloseShortsVideoUploadModal();
    try {
      dispatch(loading_Store(true));
      await chooseVideoFunc({target});
      
    } catch (error) {
      dispatch(loading_Store(false));
      console.error("Error in handleShortVideoUpload", error)
    }
  }

  const handleCloseShortsVideoUploadModal = () => {
    setOpenShortsVideoUploadModal(false);
  }

  return (
    <Box className="v-menu-body pt-2 select-none v-font-bold" ref={menuRef} onClick={deselectItems}>
      {menuinfo.map((child, index) => <Icondetail {...child} index={index} key={index} />)}

      {/* Upload Video Modal Start */}
      <Modal
        open={openShortsVideoUploadModal}
        onClose={handleCloseShortsVideoUploadModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          border: '2px solid #000',
          borderRadius: 4,
          boxShadow: 24,
          p: { xs: 2, sm: 3, md: 4 },
          width: { xs: '90%', sm: 500, md: 600 }
        }}>
          <Typography variant='h4' align='center' gutterBottom>Select Video To Create AI Shorts</Typography>

          <Box display={'flex'} flexDirection={"column"}>
            <Box>
                <label htmlFor="video_input" style={{ width: "100%" }}>
                <Button
                  variant="contained"
                  fullWidth
                  component="span"
                  sx={{ cursor: 'pointer', alignItems: 'center' ,textAlign: 'center', padding: '4px 0'}}
                >
                  Upload Video
                  <VideoFile sx={{fontSize: '48px !important'}} />
                </Button>
              </label>
              <input
                type="file"
                accept=".mp4, .m4v, .webm, .mov"
                onChange={handleShortVideoUpload}
                id="video_input"
                style={{ display: "none" }}
              />
            </Box>

            <Button
              className="mt-10"
              variant="outlined"
              size='medium'
              endIcon={<CloseIcon />}
              onClick={handleCloseShortsVideoUploadModal}
            >
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
      {/* Upload Video Modal End */}
    </Box>
  )
}
